export default __webpack_public_path__ + "static/media/book_24px.8cbed9cf.svg";